module.exports = __webpack_public_path__ + "static/img/399.296e262.png";